<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      home: state => state.app.twenty.urls.home,
      docs: state => state.app.twenty.urls.docs,
    }),
  },
};

</script>

<template>
  <v-toolbar
    class="main-toolbar"
    app
    fixed
    clipped-left
    dark
  >
    <v-toolbar-side-icon :href="home">
      <v-icon>home</v-icon>
    </v-toolbar-side-icon>
    <div class="title ml-3 mr-5">
      {{ $t('title.name') }}
      <span class="font-weight-light">
        {{ $t('title.subName') }}
      </span>
    </div>
    <v-spacer></v-spacer>
    <v-btn
      :href="home"
      flat
      dark
    >
      {{ $t('mainToolbar.links.twenty') }}
    </v-btn>
  </v-toolbar>
</template>

<style lang="scss">
  .main-toolbar {
    z-index: 20;
  }
</style>



// WEBPACK FOOTER //
// src/components/TwMainToolbar.vue